/**
 * @module slideout-menu
 */
import { Slideout } from '../../modified/slideout.modified';
import addDelegateEventListener from '../utility-functions/add-delegate-event-listener';
import { disableScroll, enableScroll } from '../utility-functions/utility-functions';

import './slideout.scss';

/**
 * Integration of the modified `{@link https://slideout.js.org/|slideout.js}` module into the project.
 * This is the integration of the module and setting up click event handlers for opening and closing the menu
 * https://github.com/mango/slideout
 * https://slideout.js.org/
 */

let toggleScrollEnabled = true;
export default () => {
  let menuOpen: Function, menuClose: Function, pwaMenuOpen: Function, pwaMenuClose: Function;

  const menu = document.querySelector('.main-menu .slideout-menu') as HTMLElement;
  const content = document.body;
  const pwaMenu = document.querySelector('.pwa-menu .slideout-menu') as HTMLElement;
  if (menu) {
    const slideoutMenu = new Slideout({
      panel: content,
      menu: menu,
      padding: menu.clientWidth,
      tolerance: 100,
      menuTriggerWidth: 50,
      itemToMove: 'menu', // menu || panel || both
      touch: false
    });

    addDelegateEventListener(document, 'click', '.js-toggle-menu', (e) => {
      e.originalEvent.preventDefault();
      slideoutMenu.toggle();
      toggleScrollEnabled ? disableScroll() : enableScroll();
      toggleScrollEnabled = !toggleScrollEnabled;
      document.dispatchEvent(
        new CustomEvent(toggleScrollEnabled ? 'rc-menu-closed' : 'rc-menu-opened', { bubbles: true })
      );
    });

    addDelegateEventListener(document, 'click', '.js-menu-close', (e) => {
      e.originalEvent.preventDefault();
      slideoutMenu.close();
      enableScroll();
        document.dispatchEvent(new CustomEvent('rc-menu-closed', { bubbles: true }));
        document.documentElement.classList.remove('slideout-open')
    });
    menuOpen = () => slideoutMenu.open();
    menuClose = () => slideoutMenu.close();
  }
  if (pwaMenu) {
    const slideoutPwaMenu = new Slideout({
      panel: content,
      menu: pwaMenu,
      padding: pwaMenu.clientWidth,
      tolerance: 100,
      menuTriggerWidth: 50,
      itemToMove: 'menu', // menu || panel || both
      touch: false
    });

    addDelegateEventListener(document, 'click', '.js-toggle-pwa-menu', (e) => {
      e.originalEvent.preventDefault();
      slideoutPwaMenu.toggle();
      toggleScrollEnabled ? disableScroll() : enableScroll();
      toggleScrollEnabled = !toggleScrollEnabled;
      document.dispatchEvent(
        new CustomEvent(toggleScrollEnabled ? 'rc-pwa-menu-closed' : 'rc-pwa-menu-opened', { bubbles: true })
      );
    });

    addDelegateEventListener(document, 'click', '.js-pwa-menu-close', (e) => {
      e.originalEvent.preventDefault();
      slideoutPwaMenu.close();
      enableScroll();
      document.dispatchEvent(new CustomEvent('rc-pwa-menu-closed', { bubbles: true }));
    });
    pwaMenuOpen = () => slideoutPwaMenu.open();
    pwaMenuClose = () => slideoutPwaMenu.close();
  }
  return {
    menuOpen,
    menuClose,
    pwaMenuOpen,
    pwaMenuClose
  };
};
